module.exports = new __parcel__URL__("SoT-Here4TN-partners-logo.2d7a3870.png").toString();